import React, { Suspense, lazy, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from './Screens/Home';
import Product from './Screens/SingleProduct';
// import Shop from './Screens/ShopPage';

import ScrollToTop from './Screens/Components/utils/ScrollToTop';
import Header from './Screens/Components/Header';
import Fallback from './Screens/Components/utils/Fallback';
import ErrorFallback from './Screens/Components/utils/ErrorBoundary';

import { ErrorBoundary } from 'react-error-boundary';
import ReactPullToRefresh from 'react-pull-to-refresh';
import { Spinner } from 'react-bootstrap';
import { Capacitor } from '@capacitor/core';


const Shop = lazy(() => delayPage(import("./Screens/ShopPage")));
const MyAccount = lazy(() => delayPage(import("./Screens/MyAccount")));

const Checkout = lazy(() => delayPage(import('./Screens/Checkout')));
const WishList = lazy(() => delayPage(import('./Screens/WishList')));
const Cart = lazy(() => delayPage(import('./Screens/Cart')));
const Login = lazy(() => delayPage(import('./Screens/Login')));
const OrderDetails = lazy(() => delayPage(import('./Screens/OrderDetails')));
const OrderComplete = lazy(() => delayPage(import('./Screens/OrderComplete')));
const UserFeedback = lazy(() => delayPage(import('./Screens/UserFeedback')));
const ForgotPassword = lazy(() => delayPage(import('./Screens/ForgotPassword')));
const PrivacyPolicy = lazy(() => delayPage(import('./Screens/PrivacyPolicy')));
const TermsConditions = lazy(() => delayPage(import('./Screens/TermsConditions')));
const AboutUs = lazy(() => delayPage(import('./Screens/AboutUs')));
const Search = lazy(() => delayPage(import('./Screens/Search')));
const ProductDetail = lazy(() => delayPage(import('./Screens/ProductDetail')));
const ProductSections = lazy(() => delayPage(import('./Screens/Components/ProductSections')));
const YourOrder = lazy(() => delayPage(import('./Screens/PreviousOrder')));
const RefundPolicy = lazy(() => delayPage(import('./Screens/RefundPolicy')));
const CancellationPolicy = lazy(() => delayPage(import('./Screens/CancellationPolicy')));
const RegisterUser = lazy(() => delayPage(import('./Screens/RegisterUser')));



// import MyAccount from './Screens/MyAccount';
// import Checkout from './Screens/Checkout';
// import WishList from './Screens/WishList';
// import Cart from './Screens/Cart';
// import Register from './Screens/RegisterUser';
// import Login from './Screens/Login';
// import OrderDetails from './Screens/OrderDetails';
// import OrderComplete from './Screens/OrderComplete';
// import UserFeedback from './Screens/UserFeedback';
// import ForgotPassword from './Screens/ForgotPassword';
// import PrivacyPolicy from './Screens/PrivacyPolicy';
// import TermsConditions from './Screens/TermsConditions';
// import AboutUs from './Screens/AboutUs';
// import Search from './Screens/Search';
// import ProductDetail from './Screens/ProductDetail';
// import ProductSections from './Screens/Components/ProductSections';
// import YourOrder from './Screens/PreviousOrder';
// import RefundPolicy from './Screens/RefundPolicy';
// import CancellationPolicy from './Screens/CancellationPolicy';
// import RegisterUser from './Screens/RegisterUser';


async function delayPage(promise) {
  await new Promise(resolve => {
    setTimeout(resolve, 300);
  });
  return promise;
}

function App(props) {

  const [totalQuantity, setTotalQuantity] = useState(0);

  let user = localStorage.getItem('user');


  return (
    <>
      <Router  >
        <Header totalQuantity={totalQuantity}
          setTotalQuantity={setTotalQuantity} />
        <ScrollToTop />
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={(e) => {
            // console.log("Reset pressed ", e);
            window.location.reload();
          }}
          onError={(e) => {
            // console.log(e);
          }}
        >
          <Suspense fallback={<Fallback />}>

            <Routes>
              <Route exact path="/"
                // Component={Home}
                element={<><Home totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> </>}
              />
              <Route path="home" element={<><Home totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/home' /></>} />
              <Route path="product" element={<Product totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />} />
              <Route path="shop" element={<><Shop totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /></>} />
              <Route path="myaccount" element={user ? <MyAccount totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />
              <Route path="cart" element={user ? <Cart totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />
              <Route path="wishlist" element={<WishList totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />} />
              <Route exact path="/register" element={<><RegisterUser /><Navigate to='/register' /></>} />
              <Route path="login" element={<Login />} />
              <Route path="forgotpassword" element={user ? <Navigate to="/" /> : <ForgotPassword totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />} />
              <Route path="checkout" element={user ? <Checkout totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />
              <Route path="orderdetails" element={user ? <OrderDetails totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />
              <Route path="OrderComplete" element={user ? <OrderComplete totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />
              <Route path="contact"
                // Component={UserFeedback}
                element={<><UserFeedback totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/contact' /></>}
              />
              <Route path="privacy-policy" element={<><PrivacyPolicy totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/privacy-policy' /></>} />
              <Route path="terms" element={<><TermsConditions totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to="/terms" /></>} />
              <Route path="about" element={<><AboutUs totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/about' /></>} />
              <Route path="product-detail" element={<ProductDetail totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />} />
              <Route path="previous-order" element={user ? <YourOrder totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /> : <Navigate to="/login" />} />

              <Route path="/search" element={<><Search totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} />
                {/* <Navigate to='/search' /> */}
              </>} />
              <Route path="/productsection" element={<><ProductSections totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/productsection' /></>} />
              <Route path='/refund-policy' element={<><RefundPolicy totalQuantity={totalQuantity} setTotalQuantity={setTotalQuantity} /><Navigate to='/refund-policy' /></>} />
              <Route path='/cancellation-policy' element={<><CancellationPolicy totalQuantity={totalQuantity} setTimeout={setTotalQuantity} /><Navigate to='/cancellation-policy' /></>} />
            </Routes>

          </Suspense>
        </ErrorBoundary>

      </Router>

    </>
  );
}

export default App;
